/**
 * Small class-name builder used by legacy components during DS migration.
 */
type ClassValue = string | number | boolean | null | undefined | ClassValue[] | Record<string, unknown>;

function flatten(input: ClassValue): string[] {
  if (!input) return [];
  if (typeof input === 'string') return input.trim() ? [input.trim()] : [];
  if (typeof input === 'number') return [String(input)];
  if (Array.isArray(input)) return input.flatMap(flatten);
  if (typeof input === 'object') {
    return Object.entries(input)
      .filter(([, v]) => Boolean(v))
      .map(([k]) => k);
  }
  return [];
}

export function cn(...inputs: ClassValue[]): string {
  return inputs.flatMap(flatten).join(' ');
}
